import React, { Component } from 'react';
import MediaUploadDialog from './MediaUploadDialog';
import { connect } from 'react-redux';

const createMediaRoute = 'media/:eventID/POST';
class MediaUploadDialogContainer extends Component {
	handleCreateMedia = async (signedUrl, file, libraryID, eventID) => {
		const {
			handlePickItem,
			onOk,
			socket,
			auth0Token,
			open,
			from,
			mediaType = 'ASSET',
		} = this.props;
		const { name, type, size } = file;

		const media = {
			name,
			src: signedUrl.split('?')[0],
			mime_type: type,
			size,
			type: mediaType,
		};
		if (libraryID) media['library_id'] = libraryID;
		if (eventID) media['event_id'] = eventID;
		if (handlePickItem) handlePickItem(media, from)();
		socket.emit(createMediaRoute, { media: [media], libraryID }, auth0Token);

		if (onOk && open) onOk();
	};

	render() {
		return <MediaUploadDialog {...this.props} handleCreateMedia={this.handleCreateMedia} />;
	}
}

const msp = ({ ws, auth }) => ({
	socket: ws.socket,
	auth0Token: auth.auth0Token,
});

export default connect(msp, null)(MediaUploadDialogContainer);
